import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";
import DataScience from "@/Components/Front/SVGS/Services/DataScience";
import {Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import LineaData2 from "@/Components/Front/SVGS/LineaData2";
import ArrowBack from "@/Components/Front/SVGS/ArrowBack";
import Masonry from "react-masonry-css";
import Header from "@/Components/Front/Header";
import Corner from "@/Components/Front/SVGS/Corner";
import Gad from "@/Components/Front/PNGS/grad-registry.png";
import ChevronRightAlt from "@/Components/Front/SVGS/ChevronRightAlt";
import {useMediaQuery} from "react-responsive";

export default function ServicesAvailable(props) {

    const [lang, setLang] = useLang(props.locale);


    const textProps = {
        lang: lang, language: props.language,
    };
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 1023px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})


    return (
        <AppLayout {...props}>
            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang} activeItem={"services-available"}/>

            <section id="data-science" className={"services-page available"}>
                {isMobileAndTabletPortrait &&
                    <>

                        <div className={"back-arrow"}>
                            <Link href={"/"}>
                                <ChevronRightAlt/>
                            </Link>
                        </div>

                        <div className={"mobile-image"}>
                            <img src="images/DataScienceSmall.svg" alt=""/>


                        </div>
                    </>
                }
                <div className="in-frame-inner">
                    {isLg &&
                        <>


                            <div className={"section-background"}>
                                <img src="images/DataScienceSmall.svg" alt=""/>

                            </div>

                        </>
                    }

                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaData2/>
                        </div>
                        <div className={"service-back-button"}>
                            <Link href={"/"}>
                                <ArrowBack/>
                            </Link>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"available-data-analysis-title-1"}/></span>
                            <span><Text {...textProps} str={"available-data-analysis-title-2"}/></span>
                        </h1>
                        <p>
                            <Text {...textProps} str={"available-data-analysis-text"} html/>

                        </p>


                    </div>



                    <div className={"back-button"}>
                        <Link href={"/"}>

                            <button>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
        </AppLayout>

    )
}
